import {getAuditLogsService} from "@/services/audit-log.service";
import {useQuery} from "@tanstack/react-query";

const AUDIT_LOG_KEY = ["audit-log"] as const;

interface AuditLogFilters {
  page?: number;
  limit?: number;
  entityType?: string;
  entityId?: string;
  action?: string;
  systemUserId?: string;
  fromDate?: string;
  toDate?: string;
}

export const useAuditLogs = (filters: AuditLogFilters = {}) =>
  useQuery({
    queryKey: [...AUDIT_LOG_KEY, filters],
    queryFn: async () => {
      const {data} = await getAuditLogsService(filters);
      if (data === undefined) throw new Error("No data");
      return data;
    },
  });
